import React, { useEffect, createElement } from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  useEffect(() => {
    // Load Wistia player script
    const script = document.createElement('script');
    script.src = 'https://fast.wistia.com/player.js';
    script.async = true;
    document.head.appendChild(script);
    // Load Wistia embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/60et0u3zqo.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      // Cleanup scripts on unmount
      if (script.parentNode) document.head.removeChild(script);
      if (embedScript.parentNode) document.head.removeChild(embedScript);
    };
  }, []);
  return <section className="pt-32 pb-20 md:pt-40 md:pb-28 bg-gradient-to-br from-gray-50 to-white" data-id="element-386">
      <div className="container-custom" data-id="element-387">
        {/* Centered Single Column Layout */}
        <div className="max-w-4xl mx-auto" data-id="element-388">
          {/* Headline - Full Width */}
          <h1 className="mb-6 leading-tight text-center" data-id="element-389">
            Stop Chasing Applicants. Get a Recruiting System.
          </h1>

          {/* Subtitle - Full Width */}
          <p className="text-body-large mb-12 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-390">
            We build the system that delivers{' '}
            <span className="font-bold text-navy" data-id="element-391">
              20 – 50 qualified interviews every month
            </span>
            . No guesswork. No chaos. Just consistent hires.
          </p>

          {/* Video - Centered */}
          <div className="mb-12" data-id="element-392">
            <div className="bg-navy rounded p-4 md:p-6 shadow-2xl max-w-3xl mx-auto" data-id="element-393">
              <div className="aspect-video bg-navy-light rounded overflow-hidden" data-id="element-394">
                <style data-id="element-395">{`
                  wistia-player[media-id='60et0u3zqo']:not(:defined) { 
                    background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/60et0u3zqo/swatch'); 
                    display: block; 
                    filter: blur(5px); 
                    padding-top: 56.25%; 
                  }
                `}</style>
                <wistia-player media-id="60et0u3zqo" aspect="1.7777777777777777" className="w-full h-full" data-id="element-396"></wistia-player>
              </div>
            </div>
          </div>

          {/* CTA Button - Centered */}
          <div className="mb-12 flex justify-center" data-id="element-397">
            <Button size="lg" href="/book-call" showArrow data-id="element-398">
              Start Your Recruiting Engine
            </Button>
          </div>

          {/* Trust Stats - Centered */}
          <div className="flex items-center justify-center gap-8 md:gap-12" data-id="element-399">
            <div className="text-center" data-id="element-400">
              <div className="text-2xl md:text-3xl font-bold text-amber mb-1" data-id="element-401">
                3,500+
              </div>
              <p className="text-sm text-gray-600" data-id="element-402">System Hires</p>
            </div>
            <div className="text-center" data-id="element-403">
              <div className="text-2xl md:text-3xl font-bold text-amber mb-1" data-id="element-404">
                $150M+
              </div>
              <p className="text-sm text-gray-600" data-id="element-405">
                Production from Hired Reps
              </p>
            </div>
            <div className="text-center" data-id="element-406">
              <div className="text-2xl md:text-3xl font-bold text-amber mb-1" data-id="element-407">
                Built by
              </div>
              <p className="text-sm text-gray-600" data-id="element-408">D2D Operators</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}